import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Whatmob() {
  return (
    <section className="what_mob p-100 text_onsite">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Results and <span>Impact</span>
            </h2>
            <p>
              The launch of OnSite Social has significantly impacted users and
              the market as expected. The users have reported a substantial
              increase in their social connections, leading to more
              opportunities for interaction. Due to the enhanced networking,
              professionals have benefited from the real-time connecting
              opportunities provided by the app
            </p>
            <p>
              Individuals have found new and exciting social opportunities by
              direct interaction with people in their vicinity. Moreover, OnSite
              Social is becoming a great source for building meaningful
              relationships, whether personal or professional. As a result,
              users have experienced improved social interactions that will lead
              to the development of a strong community.
            </p>
            <div className="what_mob_img">
              <StaticImage
                src="../../../images/case-studies/onsite/results.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1158}
                height={593}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whatmob;
